import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import PhotoCapture from '../../../components/photo-capture/photo-capture';
import type { ReceivedImagePayload } from '../../../types';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
const FACE_OUTLINE_TO_WIDTH_RATIO = 0.7;
const SelfiePhoto = () => {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.selfie-photo"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const [state, send] = useIdDocMachine();
  const {
    requirement,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  let t1;
  if ($[1] !== send) {
    t1 = payload => send({
      type: "receivedImage",
      payload
    });
    $[1] = send;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onComplete = t1;
  let t2;
  if ($[3] !== send) {
    t2 = () => {
      send({
        type: "navigatedToPrev"
      });
    };
    $[3] = send;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClickBack = t2;
  let t3;
  if ($[5] !== send) {
    t3 = () => {
      send({
        type: "cameraStuck"
      });
    };
    $[5] = send;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCameraStuck = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp2);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = {
      camera: t4,
      preview: t5
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== allowPdf || $[15] !== handleCameraStuck || $[16] !== handleClickBack || $[17] !== hasBadConnectivity || $[18] !== onComplete || $[19] !== requirement || $[20] !== t6) {
    t7 = <PhotoCapture autocaptureKind="face" cameraKind="front" deviceKind="mobile" allowPdf={allowPdf} requirement={requirement} hasBadConnectivity={hasBadConnectivity} outlineHeightRatio={FACE_OUTLINE_TO_WIDTH_RATIO} outlineWidthRatio={FACE_OUTLINE_TO_WIDTH_RATIO} title={t6} onComplete={onComplete} onBack={handleClickBack} onCameraStuck={handleCameraStuck} />;
    $[14] = allowPdf;
    $[15] = handleCameraStuck;
    $[16] = handleClickBack;
    $[17] = hasBadConnectivity;
    $[18] = onComplete;
    $[19] = requirement;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default SelfiePhoto;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.title;
}